import { Center, Container, Title } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

export const RestrictedProfile = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Center p="xl">
        <Title size="h3" order={2}>
          {t("screen_profile.dont_worry")}
        </Title>
      </Center>
    </Container>
  );
};
